module.exports = __webpack_public_path__ + "static/media/default.941c98ad.svg";